import logger from '@/common/logger';
import { translate } from '@/locales';
import { default as page, default as PageSpec } from '@/router/page';
import useAuthStore from '@/store/authStore';
import { nextTick } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
    history: createWebHistory(),
    routes: [page.APP.LANDING, page.APP.HOWTOPLAY, page.APP.ABOUT, page.APP.MYTHIC, page.APP.THESTORY, { path: '/:pathMatch(.*)*', name: 'NotFound', component: () => import('@/views/pages/NotFound.vue') }]
});

router.beforeEach(async (to, from, next) => {
    next();
    // if (whiteListUrl.includes(to.name)) {
    //     next();
    // } else if (isAuthenticated()) {
    //     await redirectIfValid(to, from, next);
    // } else {
    //     await redirectIfInvalid(to, from, next);
    // }
});

function isAuthenticated() {
    const authStore = useAuthStore();
    logger.debug(authStore.isAuthenticated);
    return authStore.isAuthenticated;
}

async function redirectIfInvalid(to, from, next) {
    if (to.path !== PageSpec.AUTH.LOGIN.path) {
        await next({
            name: PageSpec.AUTH.LOGIN.name
        });
    } else {
        next();
    }
}

async function redirectIfValid(to, from, next) {
    if (to.name === PageSpec.AUTH.LOGIN.name) {
        await next({ name: PageSpec.APP.DASHBOARD.name });
    } else if (hasPermission(to.meta.permissions ?? [])) {
        next();
    } else {
        await next({ name: PageSpec.ACCESS.DENIED.name });
    }
}

function hasPermission(permissions) {
    const authStore = useAuthStore();
    return permissions.length === 0 || containsAny(permissions, authStore.getPermissions);
}

function containsAny(arr1, arr2) {
    return arr1.some((element) => {
        return arr2.indexOf(element) !== -1;
    });
}

router.afterEach(async (to) => {
    await nextTick(() => {
        const pageTitle = translate(to.meta.title ?? to.name.toUpperCase() + '');
        document.title = pageTitle;
    });
});

export default router;
